import React from 'react'
import { formatDate } from '@/utils/dateUtilities'
import getEnumTranslation from '@/enums/enums'
import Icon from '@/components/Icon'
import { Link } from 'react-router-dom'
import Name from '@/components/Name'
import Resx from '@/components/Resx'
import { reportSubmissionGroupStatus } from '@/components/reporting/submissions/reportSubmissionsStatus'
import { Forecasting } from '@/components/reporting/forecasting'
import { Row, Col } from 'reactstrap'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { WhiteBox } from '@/components/Layout'
import { ProcessState } from '@/components/reporting/processState'
import moment from 'moment'
import { useLocalization } from '@/hooks/localization'
import { useSignalR } from '@/hooks/useSignalR'
import { actionCreators } from '@/store/ReportSubmissionGroup'
import { useDispatch } from '@/hooks/dispatch'

const RelatedTickets = ({ showRelatedLinks, reportSubmissionGroup }) => {
  const renderRelatedTickets = () => {
    const { relatedTicketIds } = reportSubmissionGroup
    if (relatedTicketIds && relatedTicketIds.length) {
      return relatedTicketIds.map((ticketId, idx) => <Link key={idx} to={`/tickets/${ticketId}`}><span className='ticket-label'><Icon name='list-alt' /> {ticketId}</span></Link>)
    }
    return <span>-</span>
  }
  if (showRelatedLinks) {
    return (<InfoRow>
      <InfoLabel><Resx name='Reporting.RelatedTickets' /></InfoLabel>
      <InfoContent>
        {renderRelatedTickets()}
      </InfoContent>
    </InfoRow>)
  }
  return null
}
const ReportGroupLink = ({ showRelatedLinks, reportGroup }) => {
  if (showRelatedLinks) {
    return (
      <InfoRow>
        <InfoLabel><Resx name='Reporting.ReportingGroup' /></InfoLabel>
        <InfoContent><Link to={`/reporting-groups/${reportGroup.id}`}><Name data={reportGroup} /></Link></InfoContent>
      </InfoRow>
    )
  }
  return null
}
const NullableDate = ({ date, title }) => {
  if (date) {
    return (
      <InfoRow>
        <InfoLabel><Resx name={title} /></InfoLabel>
        <InfoContent>{formatDate(date)}</InfoContent>
      </InfoRow>
    )
  }
  return null
}
const GroupHeader = ({ showInstitution, reportSubmissionGroup, showRelatedLinks }) => {
  const { id, snapshotDate, dueDate, extendedDueDate, state, processState, forecasting, acceptedDate, rejectedDate } = reportSubmissionGroup || {}
  const [setInstanceGroupState] = useDispatch([actionCreators.setInstanceGroupState])

  useSignalR('instanceGroupStateChanged', async (data) => {
    const parsed = JSON.parse(data)

    if (!parsed.reportInstanceGroupState) parsed.reportInstanceGroupState = 0

    if (id === parsed.reportInstanceGroupId) {
      setInstanceGroupState(parsed.reportInstanceGroupState)
    }
  }, [id, processState])

  const { localize } = useLocalization()

  if (!reportSubmissionGroup) { return null }

  const reportGroup = {
    id: reportSubmissionGroup.reportGroupId,
    name: reportSubmissionGroup.reportGroupName,
    latinName: reportSubmissionGroup.reportGroupLatinName
  }

  const status = getEnumTranslation({ localize, enumName: 'ReportSubmissionGroupState', value: state })
  const dueDatePassedCss = (moment(dueDate).isBefore(moment()) ? 'report-item__due-date--pass' : '')

  const renderInstitution = () => {
    if (showInstitution) {
      return (
        <InfoRow>
          <InfoLabel><Resx name='Reporting.InstitutionName' /></InfoLabel>
          <InfoContent><Name data={reportSubmissionGroup.institution} /></InfoContent>
        </InfoRow>
      )
    }
    return null
  }

  return (
    <WhiteBox header='Reporting.General'>
      <Forecasting forecasting={forecasting} />
      <Row>
        <Col sm='6'>
          <InfoRow>
            <InfoLabel><Resx name='Common.Name' /></InfoLabel>
            <InfoContent><Name data={reportSubmissionGroup} /></InfoContent>
          </InfoRow>
          {renderInstitution()}
          <RelatedTickets showRelatedLinks={showRelatedLinks} reportSubmissionGroup={reportSubmissionGroup} />
          <ReportGroupLink reportGroup={reportGroup} showRelatedLinks={showRelatedLinks} />
        </Col>
        <Col sm='6'>
          <InfoRow>
            <InfoLabel><Resx name='Reporting.SnapshotDate' /></InfoLabel>
            <InfoContent>{formatDate(snapshotDate)}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Reporting.DueDate' /></InfoLabel>
            <InfoContent className={dueDatePassedCss}>{formatDate(dueDate)}</InfoContent>
          </InfoRow>
          <InfoRow>
            <InfoLabel><Resx name='Reporting.ExtendedDueDate' /></InfoLabel>
            <InfoContent>{formatDate(extendedDueDate)}</InfoContent>
          </InfoRow>
          <NullableDate title='Reporting.AcceptedDate' date={acceptedDate} />
          <NullableDate title='Reporting.RejectedDate' date={rejectedDate} />
        </Col>
      </Row>
      <Row>
        <Col sm='6' />
        <Col sm='6'>
          <InfoRow>
            <InfoLabel><Resx name='Common.State' /></InfoLabel>
            <InfoContent className='border-less'>
              <span className={'status status--' + reportSubmissionGroupStatus(state)}>
                {status}
              </span>
              <ProcessState processState={processState} />
            </InfoContent>
          </InfoRow>
        </Col>
      </Row>
    </WhiteBox>
  )
}

export default GroupHeader



// WEBPACK FOOTER //
// ./src/components/reporting/submissions/groupHeader.js